function SvgTarget(props) {
  return (
    <svg
      width={28}
      height={28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.402.401V8.82h1.295V1.697H8.82V.402H.402zm18.779 0v1.295h7.123V8.82h1.295V.4H19.18zM13.353 3.64v1.963c-4.128.315-7.435 3.623-7.75 7.75H3.64v1.295h1.962c.315 4.128 3.623 7.436 7.75 7.75v1.964h1.296v-1.963c4.127-.315 7.435-3.623 7.75-7.75h1.963v-1.296h-1.963c-.315-4.127-3.623-7.435-7.75-7.75V3.64h-1.295zm0 3.268v3.268a3.898 3.898 0 00-3.177 3.177H6.908a7.112 7.112 0 016.445-6.445zm1.295 0a7.113 7.113 0 016.445 6.446h-3.268a3.897 3.897 0 00-3.177-3.177V6.907zm-1.295 4.584v1.861H11.49a2.582 2.582 0 011.862-1.861zm1.295 0a2.582 2.582 0 011.861 1.861h-1.861v-1.861zm-7.74 3.157h3.267a3.897 3.897 0 003.177 3.176v3.268a7.114 7.114 0 01-6.445-6.445zm4.583 0h1.861v1.861a2.576 2.576 0 01-1.861-1.861zm3.157 0h1.861a2.577 2.577 0 01-1.861 1.861v-1.861zm3.177 0h3.268a7.114 7.114 0 01-6.446 6.445v-3.268a3.897 3.897 0 003.177-3.177zM.4 19.18v8.418H8.82v-1.295H1.696V19.18H.401zm25.902 0v7.123H19.18v1.295h8.418V19.18h-1.295z"
        fill="#088AB2"
      />
    </svg>
  )
}

export default SvgTarget
